// extracted by mini-css-extract-plugin
export default {"photo":"HeaderProduct_photo__+ezku","card":"HeaderProduct_card__OeOYQ","titles":"HeaderProduct_titles__jbgOL","infoSection":"HeaderProduct_infoSection__qNPdj"};